import {
  Component,
  Input,
  Output,
  EventEmitter
} from '@angular/core';

@Component({
  standalone: false,
  selector: 'mobile-page-header',
  templateUrl: './mobile-page-header.component.html',
  styleUrls: ['./mobile-page-header.component.scss']
})
export class MobilePageHeaderComponent {
  @Input() closeableView = false;
  @Input() fillBackground: boolean;

  @Input() showBackBtn = true;

  @Output() onBack = new EventEmitter<void>();
  @Output() onClose = new EventEmitter<void>();

  public showMenu: boolean;
}
